 <template>
    <diV style="background-color: white; height: calc(100vh - 84px); display: flex; flex-direction: column;">
        <el-form class="demo-form-inline" :inline="true" ref="overduePicksForm" :model="overduePicksForm" 
        size="mini" label-width="80px">
            <el-form-item label="状态" > 
                <el-select clearable class="width_100" filterable :default-first-option="true" 
                    v-model="overduePicksForm.status" placeholder="请选择状态"  >
                    <el-option v-for="item in statusList"  :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo"> 
                <el-input v-model="overduePicksForm.blNo" placeholder="请输入提单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="客户经理" prop="notifyPerson">
                    <el-select clearable class="width_100" filterable :default-first-option="true" 
                    v-model="overduePicksForm.notifyPerson" placeholder="请选择客户经理"  >
                        <el-option v-for="item in userList"  :key="item.id" :label="item.name " :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="getOverduePicksList">搜索</el-button>
            </el-form-item>
        </el-form>
        <div style="flex:1;overflow: hidden" >
            <vxe-table id="overduePicksTable"  size="mini" ref="overduePicksTable" :data="overduePicksList" border stripe
            header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" height="auto">
                <!-- <vxe-column type="checkbox" fixed="left" width="50"></vxe-column> -->
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="status" title="状态"  width="100" sortable align="center">
                    <template template #default="{ row }">
                        <el-tag v-if="row.status === 0" type="danger">未提离</el-tag>
                        <el-tag type="info" v-if="row.status === 1" >已提离</el-tag>
                    </template>
                </vxe-column>
                <vxe-column field="declareDate" title="报关日期" width="110" sortable ></vxe-column>
                <vxe-column field="endDate" title="截止日期"  sortable ></vxe-column>
                <vxe-column field="blNo" title="提单号" sortable ></vxe-column>
                <vxe-column field="ckName" title="仓库名称"  ></vxe-column>
                <vxe-column field="blKgs" title="申报数量"  ></vxe-column>
                <vxe-column field="notifyPerson" title="客户经理" width="130"  ></vxe-column>
                <vxe-column field="createMan" title="创建人" width="130"  ></vxe-column>
                <vxe-column field="remark" title="备注"  ></vxe-column>
                <vxe-column title="操作" width="120" fixed="right" align="center">
                    <template template #default="{ row }">
                        <el-button type="primary" size="mini" @click="wmsChangeOverduePickStatus(row)">
                            <span v-if="row.status === 0">提离</span>
                            <span v-else>取消提离</span>
                        </el-button>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="getOverduePicksListPager" size="mini">
        </vxe-pager>
         
    </diV>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
export default {
    name: 'overduePickList',
    mixins: [userProfile],
    components:{

    },
    watch: { 
       
    },
    data() {
        return{
            overduePicksForm:{
                status:"",
                notifyPerson:"",
                blNo:"",
            },
            userList:[], // 用户数据
            overduePicksList:[],
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 50, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100,200],
            statusList:[
                {value:0,label:'未提离'},
                {value:1,label:'已提离'},
            ],
        }
    },
    created() {
        this.getOverduePicksList()
        this.getUserList()

    },
    mounted() {

    },
    methods: {
        // 获取所有用户
        getUserList(){
            this.$api.getUserList( ).then(res =>{
                this.userList = res;
            })
        },
        // 获取数据
        getOverduePicksList() { 
            this.pagination.currentPage = 1
            this.$api.wmsGetOverduePicks( this.pagination.pageSize,this.pagination.currentPage ,clean(this.overduePicksForm) ).then(async res =>{
                this.overduePicksList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        getOverduePicksListPager(){
            this.$api.wmsGetOverduePicks( this.pagination.pageSize,this.pagination.currentPage ,clean(this.overduePicksForm) ).then(async res =>{
                this.overduePicksList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 修改提离状态
        wmsChangeOverduePickStatus(row){
            this.$confirm('确定要' + (row.status === 0 ? '提离' : '取消提离') + '吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsChangeOverduePickStatus(row.id).then(res =>{
                    this.$message({
                        message: '修改提离状态成功',
                        type: 'success'
                    });
                    this.getOverduePicksListPager()
                })
            }).catch(() => {
            })
        },
    }
}
</script>